import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ConfirmationDialogComponent } from "../components/infrastructure/confirmation-dialog/confirmation-dialog.component";
import { EletronicTransferReleasesDialogComponent } from "../components/infrastructure/eletronic-transfer-releases-dialog/eletronic-transfer-releases-dialog.component";
import { EletronicTransferStatementDialogComponent } from "../components/infrastructure/eletronic-transfer-statement-dialog/eletronic-transfer-statement-dialog.component";
import { InformDialogComponent } from "../components/infrastructure/inform-dialog/inform-dialog.component";
import { RejectDialogComponent } from "../components/infrastructure/reject-dialog/reject-dialog.component";
import { DialogSize, TicketType } from "../model/domain/Entity";

import { Router } from "@angular/router";
import { CutoffDefaultManagerFundDialogComponent } from "../components/cutoff/cutoff-default-manager-fund-dialog/cutoff-default-manager-fund-dialog.component";
import { ModalCargaErrorComponent } from "../components/infrastructure/modal-carga-error/modal-carga-error";
import { ModalErrorComponent } from "../components/infrastructure/modal-error/modal-error";
import { ModalFileComponent } from "../components/infrastructure/modal-file/modal-file";
import { OperationStructuredCommentDialogComponent } from "../components/infrastructure/operation-structured-comment-dialog/operation-structured-comment-dialog.component";
import { OperationStructuredPrecedentDialogComponent } from "../components/infrastructure/operation-structured-precedent-dialog/operation-structured-precedent-dialog.component";
import { OperationStructuredReservationDialogComponent } from "../components/infrastructure/operation-structured-reservation-dialog/operation-structured-reservation-dialog.component";
import { WarningGroupDialogComponent } from "../components/infrastructure/warning-group-dialog/warning-group.component";
import { StockFundsComponent } from "../components/stock-funds/stock-funds.component";
import { TransferStatusComponent } from "../components/transfer-status/transfer-status.component";
import { ReviewersDecisionModel } from "../model/domain/ReviewersDecisionModel";
import { StructuredOperationFileModel } from "../model/domain/StructuredOperationFileModel";
import { StructuredOperationPrecedentModel } from "../model/domain/StructuredOperationPrecedentModel";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(public dialog: MatDialog, public router: Router) {}

  //#region Generic Dialogs
  confirm(
    title?: string,
    message?: string,
    okButton?: string,
    cancelButton?: string,
    size?: DialogSize
  ): Observable<boolean> {
    let width: string;
    let height: string;
    switch (size) {
      case DialogSize.Small:
        width = "350px";
        height = "200px";
        break;

      case DialogSize.Medium:
        width = "600px";
        height = "300px";
        break;

      case DialogSize.Big:
        width = "600px";
        height = "600px";
        break;

      default:
        width = "350px";
        height = "200px";
        break;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: width,
      height: height,
      data: {
        title,
        message,
        ok: okButton,
        cancel: cancelButton,
      },
    });

    return dialogRef.afterClosed();
  }

  reject(title?: string, message?: string): Observable<any> {
    const dialogRef = this.dialog.open(RejectDialogComponent, {
      width: "550px",
      height: "330px",
      data: {
        title,
        message,
      },
    });

    return dialogRef.afterClosed();
  }

  warningGroup(title?: string, message?: string): Observable<any> {
    const dialogRef = this.dialog.open(WarningGroupDialogComponent, {
      width: "450px",
      height: "250px",
      data: {
        title,
        message,
      },
    });

    return dialogRef.afterClosed();
  }

  inform(title?: string, message?: string): Observable<any> {
    const dialogRef = this.dialog.open(InformDialogComponent, {
      width: "450px",
      height: "250px",
      data: {
        title,
        message,
      },
    });

    return dialogRef.afterClosed();
  }
  //#endregion

  //#region Custom Dialogs
  eletronicTransferStatement(bankAccount: string, operationDate: Date) {
    const dialogRef = this.dialog.open(
      EletronicTransferStatementDialogComponent,
      {
        width: "800px",
        // height: '600px',
        data: {
          bankAccount: bankAccount.replace("-", ""),
          operationDate: operationDate
            .toString()
            .substring(0, operationDate.toString().length - 6),
        },
        maxWidth: "100vw !important",
        maxHeight: "100vw !important",
      }
    );

    return dialogRef.afterClosed();
  }

  eletronicTransferReleases(bankAccount: string, operationDate: Date) {
    const dialogRef = this.dialog.open(
      EletronicTransferReleasesDialogComponent,
      {
        width: "800px",
        // height: '600px',
        data: {
          bankAccount,
          operationDate,
        },
        maxWidth: "100vw !important",
        maxHeight: "100vw !important",
      }
    );

    return dialogRef.afterClosed();
  }

  modalerror(errors, ticketTypesId: number) {
    const dialogRef = this.dialog.open(ModalErrorComponent, {
      width: "1000px",
      // height: '600px',
      data: {
        errors,
        ticketTypesId,
      },
      maxWidth: "100vw !important",
      maxHeight: "100vw !important",
    });

    return dialogRef.afterClosed();
  }

  modalerrorcarga(errors, loadTypesId: number) {
    const dialogRef = this.dialog.open(ModalCargaErrorComponent, {
      width: "1000px",
      // height: '600px',
      data: {
        errors,
        loadTypesId,
      },
      maxWidth: "100vw !important",
      maxHeight: "100vw !important",
    });

    return dialogRef.afterClosed();
  }

  modalFile(file: Blob, isPdf: Boolean) {
    const dialogRef = this.dialog.open(ModalFileComponent, {
      width: "60%",
      //height: '600px',
      data: {
        file,
        isPdf,
      },
      maxWidth: "100vw !important",
      maxHeight: "100vw !important",
    });

    return dialogRef.afterClosed();
  }

  cutoffAccountManagerFundDefault(
    cutoffTypeId: number,
    cutoffName: string,
    isIndex: boolean
  ) {
    const dialogRef = this.dialog.open(
      CutoffDefaultManagerFundDialogComponent,
      {
        width: "800px",
        data: {
          cutoffTypeId: cutoffTypeId,
          cutoffName: cutoffName,
          isIndex: isIndex,
        },
        maxWidth: "100vw !important",
        maxHeight: "100vw !important",
      }
    );
    this.router.events.subscribe(() => {
      dialogRef.close();
    });

    return dialogRef.afterClosed();
  }
  //#endregion

  operationStructuredCommentDialog(model: StructuredOperationFileModel) {
    const dialogRef = this.dialog.open(
      OperationStructuredCommentDialogComponent,
      {
        width: "800px",
        data: {
          model: model,
        },
      }
    );

    return dialogRef.afterClosed();
  }

  operationStructuredReservation(ticketId: number, groupId: number[]) {
    const dialogRef = this.dialog.open(
      OperationStructuredReservationDialogComponent,
      {
        width: "800px",
        data: {
          ticketId: ticketId,
          groupId: groupId,
        },
      }
    );

    return dialogRef.afterClosed();
  }

  operationStructuredPrecedentDialog(
    model: StructuredOperationPrecedentModel,
    reviewersList: ReviewersDecisionModel[]
  ) {
    const dialogRef = this.dialog.open(
      OperationStructuredPrecedentDialogComponent,
      {
        width: "800px",
        data: {
          model: model,
          reviewersList: reviewersList,
        },
      }
    );

    return dialogRef.afterClosed();
  }

  transferStatus(ticketId: number) {
    const dialogRef = this.dialog.open(TransferStatusComponent, {
      width: "75%",
      height: "65%",
      data: {
        ticketId: ticketId,
      },
      maxWidth: "100vw !important",
      maxHeight: "100vw !important",
    });

    return dialogRef.afterClosed();
  }

  stockFundsDialog(fundSourceId: string, ticketType: TicketType) {
    const dialogRef = this.dialog.open(StockFundsComponent, {
      width: "75%",
      data: {
        fundSourceId: fundSourceId,
        ticketType: ticketType,
      },
    });

    return dialogRef.afterClosed();
  }
}
